import { object, string } from 'yup';

export const validationSchema = object().shape({
  name: string()
    .trim()
    .max(250, 'Name cannot be more than 250 characters.')
    .min(3, 'Name cannot be less than 3 characters.')
    .required('Name is required'),
});
